import { MutableRefObject, useEffect } from 'react';

export default function useOnClickOutside(ref: MutableRefObject<any>, handler: Function) {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    return () => document.removeEventListener('mousedown', listener);
  }, [handler, ref]);
}
